
import dust from "dustjs-linkedin";

import "template/widgets/loader.js";

(function(){dust.register("lessons/lesson-creator/editor/loader",body_0);function body_0(chk,ctx){return chk.write("<div class=\"loader-container\">").partial("widgets/loader",ctx,{}).write("</div>");}return body_0;})();

export default 0;
